var map = {
	"./news-1.jpg": "93ba",
	"./news-2.jpg": "ea14",
	"./news-3.jpg": "ca72",
	"./news-4.jpg": "857c",
	"./news-5.jpg": "0810",
	"./news-6.jpg": "063b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d276";